import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {SubService, SubServiceInput} from './sub-service.model';

export const loadSubServices = createAction(
  '[SubService/API] Load SubServices',
  props<{ subServices: SubService[] }>()
);

export const addSubService = createAction(
  '[SubService/API] Add SubService',
  props<{ subService: SubService }>()
);

export const upsertSubService = createAction(
  '[SubService/API] Upsert SubService',
  props<{ subService: SubService }>()
);

export const addSubServices = createAction(
  '[SubService/API] Add SubServices',
  props<{ subServices: SubService[] }>()
);

export const upsertSubServices = createAction(
  '[SubService/API] Upsert SubServices',
  props<{ subServices: SubService[] }>()
);

export const updateSubService = createAction(
  '[SubService/API] Update SubService',
  props<{ subService: Update<SubService> }>()
);

export const updateSubServices = createAction(
  '[SubService/API] Update SubServices',
  props<{ subServices: Update<SubService>[] }>()
);

export const deleteSubService = createAction(
  '[SubService/API] Delete SubService',
  props<{ id: string }>()
);

export const deleteSubServices = createAction(
  '[SubService/API] Delete SubServices',
  props<{ ids: string[] }>()
);

export const clearSubServices = createAction(
  '[SubService/API] Clear SubServices'
);


// CUSTOM
export const createSubService = createAction(
  '[SubService/API] create SubServices',
  props<{ input: SubServiceInput }>()
);


export const editSubService = createAction(
  '[SubService/API] edit SubService',
  props<{ input: SubServiceInput }>()
);


export const removeSubService = createAction(
  '[SubService/API] remove SubService',
  props<{ serviceUniqueId: string, id: string }>()
);


export const getAllSubService = createAction(
  '[SubService/API] get all SubServices',
  props<{ serviceUniqueId?: string }>()
);




